import styles from "./FilterSelectionLoadingSkeletion.module.scss";

export default function FilterSelectionLoadingSkeleton({
  skeletonKey = "",
  textBlocks = 2,
}) {
  const textBlocksArray = Array.from(
    { length: textBlocks },
    (_, index) => index
  );
  return (
    <div className={styles.filterLoading}>
      <div className={styles.filterLoadingTextContainer}>
        {textBlocksArray.map((block) => (
          <div
            className={styles.filterLoadingText}
            key={`${skeletonKey}-${block}`}
          />
        ))}
      </div>
      <div className={styles.loadingSelectionSquare} />
    </div>
  );
}
